/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { noop as r } from "../../noop.mjs";
const t = e.createContext({
  drag: void 0,
  setDrag: r,
  drop: void 0,
  setDrop: r,
  drags: [],
  registerDrag: r,
  deregisterDrag: r,
  drops: [],
  registerDrop: r,
  deregisterDrop: r
});
export {
  t as DragAndDropContext
};
